module.exports = __webpack_public_path__ + "img/defence-24-com.c72254e4.svg";